<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="cancel-button" depressed>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'WidgetCancelButton',
};
</script>

<style scoped lang="scss">
.cancel-button {
	background-color: transparent !important;
	border: 1px solid rgb(147, 161, 187) !important;
}
</style>
